export const dateFormatter = (
  dateInput: Date | string,
  type = "MM/dd/yyyy"
) => {
  let date: Date;

  // Check if the input is a string and parse it
  if (typeof dateInput === "string") {
    // Assume the format is "yyyy-MM-dd"
    const [year, month, day] = dateInput.split("-").map(Number);
    date = new Date(year, month - 1, day); // month is 0-indexed in Date
  } else {
    date = dateInput;
  }

  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const seconds = date.getSeconds().toString().padStart(2, "0");

  switch (type) {
    case "MM/dd/yyyy":
      return `${month}/${day}/${year}`;
    case "yyyy-MM-dd":
      return `${year}-${month}-${day}`;
    case "MM/dd/yyyy HH:mm:ss":
      return `${month}/${day}/${year} ${hours}:${minutes}:${seconds}`;
    default:
      return `${month}/${day}/${year}`;
  }
};
